// Step2.jsx
import React, { useState, useEffect } from "react";
import { getDesprecio, CurrencyFormatter } from "app/components/helpers/Views";
import useAuth from "app/hooks/useAuth";
import { useStore } from "react-redux";
import { ContratoContenido } from "app/components/Contrato/ContratoContenido";
import { descargarPDFContrato } from "../comunidad/FuncionesComunidades";
import { insertarEnAdminCommunities } from "app/views/comunidad/FuncionesComunidades";
import { useFirebase } from "app/firebase/context";
import { update, push, getDatabase, set, ref as firebaseRef } from "firebase/database";
import getCustomToastOptions from "app/components/helpers/getCustomToastOptions";
import { toast } from "react-toastify";
import { getFunctions, httpsCallable } from "firebase/functions";
import { useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
const circleBadgeStyle = {
  display: "inline-block",
  width: "30px",
  height: "30px",
  borderRadius: "50%",
  backgroundColor: "#172983", // Puedes cambiar el color según tus preferencias
  color: "#fff",
  textAlign: "center",
  lineHeight: "30px",
};
const firebaseConfigAdmin = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_ADMIN_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

export const Step2 = ({ onPrev, onNext, setPlan, plan, planHistorico, setModalOpen }) => {
  console.log("EL PLAN EN STEP2", plan);
  const { user } = useAuth();
  const firebase = useFirebase();
  const [paymentOption, setPaymentOption] = useState("");
  const [precioSelected, setPrecioSelected] = useState(null);
  const [precios, setPrecios] = useState({ mensual: "", anual: "" });
  const store = useStore();
  const lengu = store.getState().lenguajes;
  const diccionario = lengu.diccionario;
  const navigate = useNavigate();
  const [refrescar, setRefrescar] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleContratar = async (Comunidad) => {
    setLoading(true);
    try {
      // Actualizar el estado con la información obtenida
      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleString("es-ES", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      });

      const formattedDateStripe = currentDate
        .toLocaleString("es-ES", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        })
        .replace(/\//g, "-");

      const updatedData = {
        Alta: true,
        fechaAlta: formattedDate,
        ContratoActivo: {
          fechaInicio: formattedDate,
          fechaFin: null,
          formapago: plan.formapago,
          iban: plan.IBAN, // MIRAR SI HABRÍA QUE GUARDAR EL IBAN EN EL MOMENTO DE CONTRATAR (SEGURAMENTE SI, Y TENER EN CUENTA )
          plan: "total",
          precioSelected: plan.precioComunidad,
          vecinos: plan.vecinos,
          cuentaBancaria: plan.cuentaBancaria,
        },
      };

      // Primero paso por stripe y si es correcto doy de alta y genero el contrato

      const functions = getFunctions(firebase.app, process.env.REACT_APP_FIREBASE_ZONE);
      var startCommunityPayment = httpsCallable(functions, "startCommunityPayment");

      const deskId = user.despacho.Codigo;
      const communityId = Comunidad;
      const type = plan.iban === "administrador" ? "Despacho" : "Comunidad";
      const price = plan.precioComunidad;
      const name = `Pack ${plan.plan} - Com. ${Comunidad} (${plan.vecinos} vecinos) ${formattedDateStripe}`;
      const recurringRate = plan.formapago === "anual" ? plan.formapago : "monthly";

      startCommunityPayment({
        deskId: deskId,
        communityId: communityId,
        type: type,
        price: price,
        name: name,
        recurringRate: recurringRate,
      })
        .then(async (res) => {
          if (res.data.status !== "success") {
            toast.error(diccionario.FalloPago, getCustomToastOptions(toast, "error"));
            throw diccionario.FalloPago;
          }
          // Si el IBAN es nuevo en stripe tendremos que confirmarlo
          if (res.data.newAccount === true) {
            onNext();
          } else {
            const comUpdatear = firebase.getReferencia(`Comunidad/${Comunidad}`);
            /*
            if (esModificar == true) {
              const updatedData2 = {
                fechaInicio: planHistorico.fechaInicio,
                fechaFin: formattedDate,
                formapago: planHistorico.formapago,
                iban: planHistorico.iban, // MIRAR SI HABRÍA QUE GUARDAR EL IBAN EN EL MOMENTO DE CONTRATAR (SEGURAMENTE SI, Y TENER EN CUENTA )
                plan: planHistorico.plan,
                precioSelected: planHistorico.precio,
                vecinos: planHistorico.vecinos,
                cuentaBancaria: planHistorico.cuentaBancaria,
              };
              const comUpdatear2 = firebase.getReferencia(
                `Comunidad/${Comunidad}/HistoricoContratos`
              );

              await push(comUpdatear2, updatedData2);
            }
*/
            await update(comUpdatear, updatedData);
            await insertarEnAdminCommunities(
              plan.idInterno,
              user.despacho.Codigo,
              firebaseConfigAdmin,
              firebase
            );

            toast.success(diccionario.ContratoAceptadoPagosIniciados, getCustomToastOptions(toast));
            setRefrescar(!refrescar);
            setModalOpen(false);
            //setIsModalOpen(false);
            // RESETEAR EL FORM DE CONTRATACION
            setLoading(false);
            navigate("/tutorial" + "/" + Comunidad);
            //setEsModificar(false);
          }
        })
        .catch((e) => {
          console.log("ERROR EN EL PAGO: ", e);
          toast.error(diccionario.FalloEnElPago, getCustomToastOptions(toast, "error"));
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
      console.error("Error al bloquear/desbloquear comunidad", error);
    }
  };

  const handlePaymentOptionChange = (event) => {
    /*
    setPaymentOption(event.target.id);
    const tabPrecios = plan.tablaPrecios;
    let selectedPrecio = tabPrecios.filter((elem) => elem.idPack === plan.plan);
    const selectedPrecio2 = selectedPrecio[0].precios.filter(
      (elem) => elem.tipo === event.target.id
    );
    const desPrecio = getDesprecio(plan.vecinos);
    const selectedPrecio3 = selectedPrecio2[0].valores.filter((elem) => elem.vecinos === desPrecio);
    setPrecioSelected(selectedPrecio3[0].precio);
    setPlan({ ...plan, formapago: event.target.id, precioSelected: selectedPrecio3[0].precio });
    */
  };
  const obtenerPrecios = async () => {
    let planSeleccionado = plan.tablaPrecios.filter((elem) => elem.idPack === plan.plan);
    let precioMensual = null;
    let precioAnual = null;
    planSeleccionado[0].precios.map((elem) => {
      let getPreciosvecions = getDesprecio(plan.vecinos);
      let precioCurrent = elem.valores.filter((prec) => prec.vecinos === getPreciosvecions);
      if (elem.tipo === "mensual") {
        precioMensual = precioCurrent[0].precio;
      } else {
        precioAnual = precioCurrent[0].precio;
      }
    });

    setPrecios({ mensual: precioMensual, anual: precioAnual });
    return { mensual: precioMensual, anual: precioAnual };
  };

  useEffect(async () => {
    console.log("EL PLAN", plan);
    /*
    if (
      planHistorico.formapago !== "" &&
      planHistorico.formapago === "mensual" &&
      planHistorico.plan === plan.plan
    ) {
      setPaymentOption("mensual");
      setPlan({
        ...plan,
        formapago: "mensual",
        precioSelected: losPrecios.mensual,
      });
      setPrecioSelected(losPrecios.mensual);
    } else if (
      planHistorico.formapago !== "" &&
      planHistorico.formapago === "anual" &&
      planHistorico.plan === plan.plan
    ) {
      setPaymentOption("anual");
      setPlan({
        ...plan,
        formapago: "anual",
        precioSelected: losPrecios.anual,
      });
      setPrecioSelected(losPrecios.anual);
    } */
  }, []);
  return (
    <>
      <div style={{ display: loading === true ? "block" : "none" }}>
        <ClipLoader
          size={100}
          color={"#123abc"}
          loading={loading}
          cssOverride={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
          speedMultiplier={1}
        />
      </div>
      <div style={{ display: loading !== true ? "block" : "none" }}></div>
      <div
        style={{ marginTop: "-20px", display: loading !== true ? "block" : "none" }}
        className="alta365"
      >
        <div className="container mt-4">
          <div className="d-flex align-items-center">
            <div style={circleBadgeStyle} className="mr-2">
              2
            </div>

            <h5 style={{ marginLeft: "15px", marginBottom: "0px" }}>
              {diccionario.ResumenDeLaContratacion}:
            </h5>
          </div>
        </div>
        <hr />

        <ContratoContenido ContenidoPlan={plan} />

        <div className="alta365-planes-botones">
          <button className="btn btn-outline-secondary px-4" onClick={onPrev}>
            {diccionario.Volver}
          </button>
          <button
            className="btn btn-outline-primary px-4"
            onClick={() => descargarPDFContrato(plan, plan.plan + "_" + plan.formapago)}
            style={{ marginLeft: "auto" }}
          >
            {diccionario.DescargarContrato}
          </button>
          <button
            onClick={() => handleContratar(plan.idInterno)}
            className="btn btn-primary px-4"
            //disabled={!aceptarTerminos}
          >
            {diccionario.Contratar}
          </button>
        </div>
      </div>
    </>
  );
};

export default Step2;
